import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Rect, { width: "18", height: "12", x: "3", y: "8", rx: "1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M10 8V5c0-.6-.4-1-1-1H6a1 1 0 0 0-1 1v3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M19 8V5c0-.6-.4-1-1-1h-3a1 1 0 0 0-1 1v3", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "ToyBrick";
const ToyBrick = memo(themed(Icon));
export {
  ToyBrick
};
//# sourceMappingURL=toy-brick.js.map
